module.exports = __webpack_public_path__ + "src/assets/img/i-stop.f48ebb32.svg";